import Vue from "vue";

export class Entrocamento {
    static create() {
        return {
            nome: null,
            place: [0, 0],
            obs: null
        };
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byID(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("entroncamento/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static excluir(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("entroncamento/" + id)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("entroncamentos")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("entroncamento/" + data._id, data);
            } else {
                promisse = Vue.http.post("entroncamento/0", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }
}
